import * as DashboardActions from './dashboard.actions';

export const dashboardFeatureKey = 'dashboard';

export { DashboardActions };
